var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(_vm._b({}, "button", _vm.btnAttrs, false), _vm.$listeners),
    [
      _vm.$slots.default
        ? _vm._t("default")
        : [_vm._v("\n    " + _vm._s(_vm.btnContent) + "\n  ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }